import { subscribeToConversation } from '../channels/conversation_channel'

export default class ConversationController {
  initialize() {
    this.currentUserId = parseInt(document.querySelector('meta[name="current-user-id"]')?.content, 10)
    this.sentMessageIds = new Set()
    this.subscription = null

    if (this.conversationIdValue) {
      this.subscription = subscribeToConversation(this.conversationIdValue, (msg) => this.handleIncomingMessage(msg))
    }
  }

  handleIncomingMessage(msg) {
    if (this.sentMessageIds.has(msg.id)) return

    const isMine = msg.sender_id === this.currentUserId
    this.appendMessage({
      body: msg.body,
      created_at: msg.created_at,
      isMine
    })
  }

  send() {
    const body = this.inputTarget.value.trim()
    if (!body) return

    this.sendBtnTarget.disabled = true
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    return fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json'
      },
      body: JSON.stringify({ body })
    })
    .then(response => {
      if (!response.ok) return response.json().then(data => { throw new Error(data.error || 'Error al enviar') })
      return response.json()
    })
    .then(data => {
      this.inputTarget.value = ''
      this.sentMessageIds.add(data.id)
      this.appendMessage(data)
    })
    .catch(error => {
      console.error('Message send error:', error)
    })
    .finally(() => {
      this.sendBtnTarget.disabled = false
      this.inputTarget.focus()
    })
  }

  appendMessage(data) {
    const emptyMsg = this.messagesTarget.querySelector('.text-muted.text-center')
    if (emptyMsg) emptyMsg.remove()

    const isMine = data.isMine !== undefined ? data.isMine : true
    const time = new Date(data.created_at).toLocaleTimeString('es-UY', { hour: '2-digit', minute: '2-digit' })
    const html = `
      <div class="message ${isMine ? 'message--mine' : 'message--theirs'}">
        <div class="message__bubble">
          <p class="message__body">${this.escapeHtml(data.body)}</p>
          <time class="message__time">${time}</time>
        </div>
      </div>
    `
    this.messagesTarget.insertAdjacentHTML('beforeend', html)
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
  }

  handleKeydown(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      this.send()
    }
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-controller="conversation"]').forEach(el => {
    const controller = new ConversationController()
    controller.element = el
    controller.urlValue = el.dataset.conversationUrlValue
    controller.conversationIdValue = el.dataset.conversationIdValue
    controller.inputTarget = el.querySelector('[data-conversation-target="input"]')
    controller.sendBtnTarget = el.querySelector('[data-conversation-target="sendBtn"]')
    controller.messagesTarget = el.querySelector('[data-conversation-target="messages"]')

    if (!controller.inputTarget || !controller.sendBtnTarget) return

    controller.initialize()

    controller.sendBtnTarget.addEventListener('click', (e) => {
      e.preventDefault()
      controller.send()
    })

    controller.inputTarget.addEventListener('keydown', (e) => {
      controller.handleKeydown(e)
    })

    // Scroll to bottom on load
    if (controller.messagesTarget) {
      controller.messagesTarget.scrollTop = controller.messagesTarget.scrollHeight
    }
  })
})
